import {
  GRETA_LIMIT_COMPOSER_PLACEHOLDER_KEY,
  GRETA_LOCKED_COMPOSER_PLACEHOLDER_KEY,
} from './GretaAIChatComposer.constants'

export function getGretaAIChatComposerPlaceholderKey({
  isLimitReached,
  isLocked,
  placeholderKey,
}) {
  if (isLocked) {
    return GRETA_LOCKED_COMPOSER_PLACEHOLDER_KEY
  }

  if (isLimitReached) {
    return GRETA_LIMIT_COMPOSER_PLACEHOLDER_KEY
  }

  return placeholderKey
}
